/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim2DiagMinRightIcon16Light = forwardRef('ArrowDim2DiagMinRightIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "m10.707 6 3.647-3.646a.5.5 0 0 0-.708-.708L10 5.293V2.5a.5.5 0 0 0-1 0V6a1 1 0 0 0 1 1h3.5a.5.5 0 0 0 0-1h-2.793Z" }),
        React.createElement("path", { d: "M6 13.5v-2.793l-3.646 3.647a.5.5 0 0 1-.708-.708L5.293 10H2.5a.5.5 0 0 1 0-1H6a1 1 0 0 1 1 1v3.5a.5.5 0 0 1-1 0Z" })));
});
